
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventBus } from "@/event-bus";
import { IPageResponse } from "@/services";
import { Getter } from "vuex-class";
import { IClientParams, ICountry, IServicepointParams, IUser } from "@/entities";
import IconFilter from "@/components/common/icon/IconFilter.vue";
import Multiselect from "vue-multiselect";
import VueMethods from "@/vue-methods";
import { SERVICEPOINT_TYPE } from "@/constans";

@Component({
  components: {
    IconFilter,
    Multiselect,
  },
  mixins: [VueMethods],
})
export default class ServicepointsFilter extends Vue {
  @Prop({ required: true, default: null }) params!: IClientParams;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  @Getter("getCountriesPage") countriesPage: IPageResponse<ICountry> | undefined;
  paramsEdit: IServicepointParams = Object.assign({}, this.params);
  valid = true;
  visible = false;
  visibleCountry = false;
  servicepoint_type_options = Object.values(SERVICEPOINT_TYPE);

  get optionsCountries(): ICountry[] {
    if (this.loggedUser?.admin) {
      this.visibleCountry = true;
      if (this.loggedUser?.userType == "CLIENTE") {
        return (
          this.countriesPage?.content.filter(
            (country) => this.loggedUser?.country?.id === country.id
          ) || []
        );
      }
      return this.countriesPage?.content || [];
    } else if (this.loggedUser?.country?.id) {
      this.visibleCountry = false;
      return (
        this.countriesPage?.content.filter(
          (country) => this.loggedUser?.country?.id === country.id
        ) || []
      );
    }
    return [];
  }

  get countrySelected(): ICountry | undefined {
    return this.optionsCountries?.find((option) => option.id === this.paramsEdit.countryId);
  }

  set countrySelected(value: ICountry | undefined) {
    this.paramsEdit.countryId = value?.id;
  }

  get filterLength(): number {
    let length = 0;
    Object.entries(this.params).forEach(([key, value]) => {
      if (
        value &&
        key !== "active" &&
        key !== "direction" &&
        key !== "orderBy" &&
        key !== "page" &&
        key !== "size"
      ) {
        length++;
      }
    });
    return length;
  }

  doCleanUp(): void {
    Object.keys(this.paramsEdit).forEach((key) => {
      (this.paramsEdit as any)[key] = undefined;
    });

    this.$emit("update:params", Object.assign({}, this.paramsEdit));
    EventBus.$emit("update-servicepoints-table");
  }

  doFilter(): void {
    this.$emit("update:params", Object.assign({}, this.cleanUpEmptyStrings(this.paramsEdit)));
    EventBus.$emit("update-servicepoints-table");
    this.visible = false;
  }
}
